import http from '@/libs/http'
// import µUtils from "../libs/utils"

/*
	NOTICE:
	- every action starts with an underscore
*/

const actions: any = {
	async _fetchSunData({ state, dispatch }: any) {
		try {
			// const resp = await axios.get(env.apiUrl + `/api/v1/sundata`, await dispatch('_config'))
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/sundata`)
      return resp


		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},
	// async _listCustomGraphs({ state, dispatch }: any) {
	// 	try {
	// 		const resp = await axios.get(env.apiUrl + `/api/v1/customgraphs/list`, await dispatch('_config'))
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },

	// async _addCustomGraph({ state, dispatch }: any, data: any) {
	// 	try {
	// 		const resp = await axios.post(env.apiUrl + `/api/v1/customgraphs/add`, data, await dispatch('_config'))
	// 		await dispatch('_initAdmin', ['customGraphs', 'alerts'])
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },

	// async _updateCustomGraph({ state, dispatch }: any, data: any) {
	// 	// console.log('_updateCustomGraph')
	// 	// console.log(data)
	// 	try {
	// 		const resp = await axios.post(env.apiUrl + `/api/v1/customgraphs/update`, data, await dispatch('_config'))
	// 		await dispatch('_initAdmin', ['customGraphs', 'alerts'])
	// 		return resp.data
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },
	async _updateCustomGraphAlertData({ state, dispatch }: any, data: any) {
		try {
			// const resp = await axios.post(
			// 	env.apiUrl + `/api/v1/customgraphs/alertdata/update`,
			// 	data,
			// 	await dispatch('_config'),
			// )
			// await dispatch('_initAdmin', ['customGraphs', 'alerts'])
			// return resp.data
      const resp = await http.postAuth<any>(`/api/v1/customgraphs/alertdata/update`, data)
      await dispatch('_initAdmin', ['customGraphs', 'alerts'])
      return resp
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},

	// //!! NEW CHART API
	// async _customGraphRecords({ state, dispatch }: any, cgId: any) {
	// 	try {
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/customgraphs/records/${cgId}`, await dispatch('_config'))
	// 		console.log(resp.data.data)
	// 		return resp.data?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },

	// async _customGraphLDeepRecords({ state, dispatch }: any, data: any) {
	// 	try {
	// 		const resp = await axios.get(env.apiUrl + `/api/v2/customgraphs/deep/${data.graphId}/${data.tsFrom}/${data.tsTo}`, await dispatch('_config'))
	// 		console.log(resp.data.data)
	// 		return resp.data?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },
	// async _recalculateCustomGraph({ state, dispatch }: any, data: any) {
	// 	try {
	// 		const resp = await http.get(`/api/v2/customgraphs/recalculate-records/${data.graphId}`)
	// 		return resp?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },
	// async _recalculateModul({ state, dispatch }: any, data: any) {
	// 	try {
	// 		const resp = await http.get(`/api/v2/modules/recalculate-records/${data.modulSerial}`)
	// 		return resp?.data || {}
	// 	} catch (error: any) {
	// 		console.error(error)
	// 		const msg = error.response?.data?.msg || error.response?.data || error.message
	// 		throw new Error(msg)
	// 	}
	// },

	// _recalculateCustomGraph
	// _recalculateModul

	async _customGraphLogs({ state, dispatch }: any, cgId: any) {
		try {
			// const resp = await axios.get(env.apiUrl + `/api/v1/customgraphs/logs/${cgId}`, await dispatch('_config'))
			// return resp.data
      const resp = await http.getAuth<any>(`/api/v1/customgraphs/logs/${cgId}`)
      return resp
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},

	async _deleteCustomGraph({ state, dispatch }: any, _id: any) {
		try {
			// const config = await dispatch('_config')
			// const resp = await axios.delete(env.apiUrl + `/api/v1/customgraphs/delete/${_id}`, config)
			// await dispatch('_initAdmin', ['customGraphs', 'alerts'])
			// return resp.data
      const resp = await http.deleteAuth<any>(`/api/v1/customgraphs/delete/${_id}`)
      await dispatch('_initAdmin', ['customGraphs', 'alerts'])
      return resp
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			throw new Error(msg)
		}
	},
}

export default actions
